import React from 'react';

export default class Arrow extends React.Component {
  render() {
    const { flip, fill, id, scale: s } = this.props;
    return (
      <marker
        id={id || (flip ? 'arrow2' : 'arrow')}
        markerWidth={8 * s}
        markerHeight={20 * s}
        refX={10 * s}
        refY={2 * s}
        orient='auto'
        markerUnits='strokeWidth'
      >
        <path
          d={
            !flip
              ? `M0,0 L0,${4 * s} L${8 * s},${2 * s} z`
              : `M${8 * s},0 L${8 * s},${4 * s} L0,${2 * s} z`
          }
          style={{ fill: fill || 'black', stroke: fill || 'black' }}
        />
      </marker>
    );
  }
}

Arrow.defaultProps = {
  flip: false,
  scale: 1
};
